__turbopack_context__.v({
  "contentWrp": "responsiveModal-module-scss-module__7h1N0q__contentWrp",
  "isLoading": "responsiveModal-module-scss-module__7h1N0q__isLoading",
  "modalFooter": "responsiveModal-module-scss-module__7h1N0q__modalFooter",
  "modalWrp": "responsiveModal-module-scss-module__7h1N0q__modalWrp",
});
